import React from 'react';
import styles from './ErrorHandler.module.scss';
import { useSelector } from 'react-redux';
import ModalIcon from '../../Icon/Icon';
import { store } from '../../../../../store';
import { ERROR_HANDLING_SERVICES } from '../../../../../store/actions/types';
import { getTranslation } from '../../../../../utils/translation';
import Button from '../../Button/Button';
import LocalStorage from '../../../../../utils/localStorage';

const ErrorHandler = () => {
    const { errorHandlerMessage, errorHandlerTitle, errorHandlerOnlyCloseButton } = useSelector(
        state => state.auth
    );
    function closeModal() {
        store.dispatch({
            type: ERROR_HANDLING_SERVICES,
            payload: {
                visible: false,
            },
        });
    }

    return (
        <div className={styles.errorHandler}>
            <div className={'flex'}>
                <ModalIcon iconKey='status' />
                <h2 className={styles.title}>{errorHandlerTitle}</h2>
            </div>
            <p>{errorHandlerMessage}</p>
            <div className={styles.actions}>
                {errorHandlerOnlyCloseButton ? (
                    <Button
                        secondary
                        width='183px'
                        onClick={closeModal}
                        spacing='2px'
                        autoMargin
                        title={getTranslation('errorModalCloseButton')}
                    />
                ) : (
                    <>
                        <Button
                            secondary
                            width='183px'
                            onClick={() => window.location.reload()}
                            spacing='2px'
                            autoMargin
                            title={getTranslation('errorModalRefreshButton')}
                        />
                        <Button
                            className={styles.refreshBtn}
                            width='183px'
                            onClick={() => {
                                window.location = '/';
                                sessionStorage.clear();
                                LocalStorage.clear();
                            }}
                            spacing='2px'
                            autoMargin
                            title={getTranslation('errorModalLogoutButton')}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default ErrorHandler;
